module.exports = __webpack_public_path__ + "img/7.1b2fe93c.jpg";